import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Logger } from '@app/core';
import { FilterService } from '@progress/kendo-angular-grid';
import { FormBuilder } from '@angular/forms';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';

const log = new Logger('KendoEventGroupSelectComponent');

@Component({
  selector: 'app-kendo-event-group-select',
  templateUrl: './kendo-event-group-select.component.html',
  styleUrls: ['./kendo-event-group-select.component.scss'],
})
export class KendoEventGroupSelectComponent extends CustomKendoFilter implements OnInit, OnChanges {
  @Input() field = 'event_group_id';

  constructor(private formBuilder: FormBuilder, filterService: FilterService) {
    super(filterService);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      event_group_id: [null],
      event_group: [null],
    });

    const eventGroup = this.getObjectFromStorage(this.field, 'event-groups');

    if (eventGroup) {
      setTimeout(() => {
        this.form.patchValue({
          event_group: eventGroup,
          event_group_id: eventGroup.id,
        });
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Изчиства формата
    // Използва се, за да чисти филтрите, когато се сетне null state на таблицата
    if (this.form && changes && changes.filter && !changes.filter.currentValue) {
      this.form.reset();
    }
  }

  onSelect(event: any) {
    CustomKendoFilter.pushObjectInStorage(event, 'event-groups');

    this.filter = this.removeFilter(this.field);

    const filters = [];
    if (event) {
      filters.push({
        field: this.field,
        operator: 'eq',
        value: event.id,
      });
    }

    const root = this.filter || {
      logic: 'and',
      filters: [],
    };

    if (filters.length) {
      root.filters.push(...filters);
    }
    this.filterService.filter(root);
    log.debug('filters', filters);
  }
}
